import { render } from "./AppStorage.vue?vue&type=template&id=450810d7"
import script from "./AppStorage.vue?vue&type=script&lang=js"
export * from "./AppStorage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__